import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { combineLatest, filter, map, take } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

export const loginGuard: CanActivateFn = (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return combineLatest([
    authService.isLoading$,
    authService.isAuthenticated$,
  ]).pipe(
    // Wait until the SDK finishes processing the redirect
    filter(([loading]) => !loading),
    take(1),
    map(([_, isAuthenticated]) => {
      if (isAuthenticated) {
        // If already authenticated, redirect to dashboard
        router.navigate(['/dashboard']);
        return false;
      }
      // Allow access to login page
      return true;
    })
  );
};
